import React, { useEffect, useState } from "react";
import api, { inr } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { User } from "lucide-react";

export default function AdminCustomersPage() {
  const [customers, setCustomers] = useState([]);
  const [active, setActive] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(false);

  useEffect(() => { api.get("/admin/customers").then(({ data }) => setCustomers(data)); }, []);

  const openCustomer = async (c) => {
    setActive(c);
    setLoadingOrders(true);
    try {
      const { data } = await api.get(`/admin/customers/${c.id}/orders`);
      setOrders(data);
    } finally { setLoadingOrders(false); }
  };

  return (
    <div data-testid="admin-customers-page" className="space-y-8">
      <div>
        <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-2">People</p>
        <h1 className="font-heading text-4xl font-bold tracking-tight">Customers</h1>
      </div>

      <div className="bg-white border border-slate-100 rounded-3xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-welljio-tint">
            <tr className="text-left">
              <th className="px-5 py-3 font-medium text-welljio-muted">Name</th>
              <th className="px-5 py-3 font-medium text-welljio-muted">Email</th>
              <th className="px-5 py-3 font-medium text-welljio-muted">Role</th>
              <th className="px-5 py-3 font-medium text-welljio-muted">Orders</th>
              <th className="px-5 py-3 font-medium text-welljio-muted">Joined</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} data-testid={`customer-row-${c.id}`} className="border-t border-slate-100 hover:bg-welljio-tint/30">
                <td className="px-5 py-4 font-medium">{c.name}</td>
                <td className="px-5 py-4 text-welljio-muted">{c.email}</td>
                <td className="px-5 py-4"><span className="text-xs px-2.5 py-1 rounded-full bg-welljio-highlight text-welljio-accent capitalize">{c.role}</span></td>
                <td className="px-5 py-4">{c.order_count}</td>
                <td className="px-5 py-4 text-welljio-muted text-xs">{c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN") : "—"}</td>
                <td className="px-5 py-4 text-right">
                  <button data-testid={`view-customer-${c.id}`} onClick={() => openCustomer(c)} className="text-xs text-welljio-accent hover:underline">View orders</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="customer-orders-dialog" className="max-w-3xl bg-white max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-welljio-ink text-white flex items-center justify-center"><User className="w-4 h-4" strokeWidth={1.5}/></span>
              {active?.name}
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-welljio-muted">{active?.email}</p>
          <div className="mt-6 space-y-3">
            {loadingOrders ? <p className="text-welljio-muted text-sm">Loading orders...</p> :
              orders.length === 0 ? <p className="text-welljio-muted text-sm">This customer has not placed any orders yet.</p> :
              orders.map((o) => (
                <div key={o.id} className="border border-slate-100 rounded-2xl p-4 flex items-center justify-between">
                  <div>
                    <p className="font-mono text-xs">{o.id.slice(-10)}</p>
                    <p className="text-xs text-welljio-muted">{o.items?.length} item · {new Date(o.created_at).toLocaleDateString("en-IN")}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium">{inr(o.total)}</p>
                    <p className="text-xs text-welljio-muted capitalize">{({placed:"pending",confirmed:"processing",out_for_delivery:"shipped"}[o.tracking_status]) || o.tracking_status || "pending"}</p>
                  </div>
                </div>
              ))
            }
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
